import { FC } from 'react';
import styles from '../Default.module.css';

export const MainShop: FC = () => {

  return (
    <div className={styles.container}>
      
    </div>
  );
}; 